"use client";

import React from "react";
import { Package, CreditCard, Truck, Boxes, Smartphone, Receipt } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * CreateWebshop — Section 4: 6 Webshop-Features
 * Drop-in für: src/pages/CreateWebshop/sections/WebshopFeatures.tsx
 */

const features = [{
  icon: Package,
  title: "Bis 50 Produkte einpflegen",
  description: "Wir pflegen alle Ihre Produkte ein — mit Bildern, Beschreibungen und Varianten. Sie liefern die Daten, wir machen den Rest."
}, {
  icon: CreditCard,
  title: "Stripe + Twint Anbindung",
  description: "Kreditkarten weltweit über Stripe. Schweizer Zahlungen über Twint. Beides vorkonfiguriert und PCI-compliant."
}, {
  icon: Truck,
  title: "Versand-Konfiguration",
  description: "Versandkosten nach Region, Pauschalen, Gratis-Versand ab Bestellwert — alles flexibel einstellbar."
}, {
  icon: Boxes,
  title: "Lagerverwaltung",
  description: "Bestände werden automatisch reduziert. Niedrige Bestände lösen Mail-Alerts aus. Nie wieder leere Lager-Überraschung."
}, {
  icon: Smartphone,
  title: "Mobiloptimierter Checkout",
  description: "60 % der Käufe passieren auf dem Handy. Der Checkout ist auf Touch optimiert — keine Eingabe-Kämpfe."
}, {
  icon: Receipt,
  title: "MWST &amp; Rechnungen",
  description: "Schweizer MWST-Regeln vorkonfiguriert. Automatisierte PDF-Rechnungen per Mail nach jeder Bestellung."
}];
export default function WebshopFeatures() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-secondary py-20 md:py-24">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Alles, was ein Schweizer Shop braucht
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Vorkonfiguriert, gehostet, einsatzbereit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => <div key={i} className="group bg-background border border-border rounded-xl p-7 hover:border-primary/40 hover:shadow-xl transition-all duration-300">
              <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white transition-colors">
                <f.icon className="w-6 h-6" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-2 tracking-tight">
                {f.title}
              </h3>
              <p className="text-base leading-relaxed text-muted-foreground">
                {f.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}